import {Severity} from '../common/common.models';

export class BasicModalModel {
    title: string;
    message: string;
    ok: string;
    styleClass?: string;
    severity?: Severity;

    constructor(title: string, message: string, ok?: string, styleClass?: string, severity?: Severity) {
      this.title = title;
      this.message = message;
      this.styleClass = styleClass ?? '';
      this.severity = severity ?? 'primary';

      if(ok){
        this.ok = ok;
      } else {
        this.ok = 'OK';
      }
    }
}
